import { render } from "./Pencil.vue?vue&type=template&id=2dfe351b"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Pencil.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2dfe351b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dfe351b', __exports__)) {
    api.reload('2dfe351b', __exports__)
  }
  
  module.hot.accept("./Pencil.vue?vue&type=template&id=2dfe351b", () => {
    api.rerender('2dfe351b', render)
  })

}


export default __exports__